
import {PhpDataProvider} from "./src/PhpDataProvider/PhpDataProvider";
import {SearchWhispererHtmlElement} from "./src/SearchWhisperer/SearchWhispererHtmlElement";
import {UserInterfaceHtmlElements} from "./src/UserInterfaceHtmlElements/UserInterfaceHtmlElements";
import {loadWhispererSuggestionsListAsPromise} from "./src/loadWhispererSuggestionsListAsPromise/loadWhispererSuggestionsListAsPromise";
import {runSearch} from "./src/runSearch/boldSearchPatterInString";

window.addEventListener('DOMContentLoaded', () => {

    const userInterface = new UserInterfaceHtmlElements();
    const phpData       = new PhpDataProvider();

    // Must be global 'var' variable not let.
    var isWhispererSuggestionListLoaded: boolean = false;
    var whispererSuggestionList: string[] | undefined;

    // Registrujeme custom SearchWhispererHtmlElement. Vytvorime jej. Provedeme potrebna nastaveni. A pripmene na body.
    customElements.define('search-whisperer', SearchWhispererHtmlElement);
    const searchWhisperer = document.createElement('search-whisperer') as SearchWhispererHtmlElement;
    searchWhisperer.setPositionUnderSearchBar();
    (document.querySelector('body') as HTMLBodyElement).prepend(searchWhisperer);

    // Whisperer
    userInterface.searchInputField.addEventListener('keyup', (event: KeyboardEvent) => {

        // Pokud je search field prazdny, neprovadime zadnou akci.
        if (userInterface.searchInputField.value.length === 0) {
            return;
        }

        // Search started by pressing enter.
        if ([ 'Enter', 'NumpadEnter' ].includes(event.code)) {
            if (userInterface.searchInputField.value.length === 0 && ! userInterface.isSearchRunning) {
                return;
            }

            runSearch(userInterface, searchWhisperer, phpData.domain);
            return;
        }

        if (event.code === 'ArrowUp') {
            searchWhisperer.setPreviousItemAsActive();
            return;
        }
        else if (event.code === 'ArrowDown') {
            searchWhisperer.setNextItemAsActive();
            return;
        }

        // Loading the list of suggestions if not loaded yet.
        if (! isWhispererSuggestionListLoaded) {
            isWhispererSuggestionListLoaded = true;

            loadWhispererSuggestionsListAsPromise(phpData.domain)
                .then(response => response.json())
                .then(data => {

                    whispererSuggestionList = data as string[];

                    searchWhisperer.setSuggestionsList(whispererSuggestionList);

                    if (! userInterface.isSearchRunning) {
                        searchWhisperer.showSuggestions(userInterface.getSearchQuery());
                    }
                })
                .catch(() => {
                    console.log('Retrieving suggestions failed.')
                });
        }
        else if (isWhispererSuggestionListLoaded
            && whispererSuggestionList !== undefined
            && ! userInterface.isSearchRunning
        ) {
            searchWhisperer.showSuggestions(userInterface.getSearchQuery());
        }

    });

    // Pokud se zmenil text ve vyhledavacim boxu a vyhledavaci boxu je prazdny, schovame naseptavac.
    userInterface.searchInputField.addEventListener('input', (event) => {
        if ((event.target as HTMLInputElement).value.length === 0) {
            searchWhisperer.hideSuggestions();
        }
    });

    // Vyhledavani odstartovane kliknutim na ikonku lupy.
    userInterface.iconMagnifyingGlass.addEventListener('click', () => {
        if (userInterface.getSearchQuery().length === 0 && ! userInterface.isSearchRunning) {
            return;
        }

        runSearch(userInterface, searchWhisperer, phpData.domain);
    });

});


